<section [ngStyle]="{ 'background-color': contentColor }" [ngClass]="bannerMarginClass" class="d-flex align-items-center new-feature-alert text-16" *ngIf="showQuickTourBanner">
	<icon [ngStyle]="{ 'background-color': headerColor }" class="icon d-flex align-items-center padding-horizontal-5 icon-holder margin-right-30" [type]="iconType"></icon>
	<div class="padding-vertical-10">
		<div class="padding-horizontal-5 margin-vertical-10 teamsite-content" [dcrHTMLKey]="featureName + '_NEW_FEATURE_TEXT'">
			<span>{{ featureName + '_NEW_FEATURE_TEXT' }}</span>
		</div>
		<a
			class="text-bold hover-pointer"
			(click)="openTourModal()"
			custom-tracking
			[track-event]="dialogLocation.toLowerCase() + ':dialog:' + featureName?.toLowerCase() + ' show tour'"
			*ngIf="isClickable"
		>
			<icon type="angle-right"></icon> <span dcrHTMLKey="TAKE_A_QUICK_TOUR_TEXT">Take a quick Tour</span>
		</a>
	</div>
	<dz-icon class="btn padding-top-10 padding-right-10" type="times" (click)="closeTourModal()"></dz-icon>
</section>
